import { formatTimestampView } from '../utils/functions';
// columns machinetype
export const MachinetypeColumns = [
    /*{
        // aus den columns id entfernen, wenn sie nicht in der Tabelle erscheinen soll
        Header: 'Id', 
        accessor: 'id_machinetype',
        disableFilters: true, // Filtermoeglichkeit für id entfernt
        sticky: 'left' // Spalte links fixieren
    },*/
    {
        Header: 'Name Maschinentyp',
        accessor: 'machinetype_name',
        sticky: 'left' // Spalte links fixieren
    },
    {
        Header: 'Letzte Änderung',
        accessor: 'timestamp',
        /*Cell: ({ value }) => formatTimestampView(value),*/
        Cell: ({ value }) => formatTimestampView(value),
            sortType: (rowB, rowA) => {
            // Direktes Vergleichen der Timestamp-Werte für korrektes Sortieren
            const timestampA = rowA.values.timestamp;
            const timestampB = rowB.values.timestamp;

            return new Date(timestampB) - new Date(timestampA);
        } 
    },
    {
        Header: 'Hersteller',
        accessor: 'manufacturer_name', // dropdown
    },
    {
        Header: 'Institution',
        accessor: 'institution_name', // dropdown - wird nur in Tabelle angezeigt
    },
    {
        Header: 'Bereich',
        accessor: 'department_name', // dropdown
    },
    {
        Header: 'Feinheit',
        accessor: 'fineness',
    },
    {
        Header: 'Nadeltyp',
        accessor: 'needletype',
    },
    {
        Header: 'max. Arbeitsbreite',
        accessor: (row) => {
            // Kombiniere Länge und Einheit
            const max_workingwidth = row.max_workingwidth;
            const unit = row.unit_max_workingwidth_name;
            if (!max_workingwidth && !unit) return null; // Fallback, falls Werte fehlen            
            return `${max_workingwidth} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const numericValue = parseInt(value);           
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return numericValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const max_workingwidth = parseInt(value);
                if (isNaN(max_workingwidth)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "m":
                        return max_workingwidth * 1000 ; // 1 m = 1000 mm
                    case "mm":
                        return max_workingwidth; // bereits in mm
                    default:
                        return max_workingwidth; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['max. Arbeitsbreite']);
            const mmsB = convertToMM(rowB.values['max. Arbeitsbreite']);           
            return mmsA - mmsB;
        },
        
        /*accessor: row => `${row.max_workingwidth} ${row.unit_max_workingwidth_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const numericValue = parseInt(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return numericValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'max. Anzahl Fadenführer',
        accessor: 'max_yarncarrier',
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const numericValue = parseInt(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return numericValue < 0 ? '' : value;
        },
    },
    {
        Header: 'Anzahl Stricksysteme',
        accessor: 'knittingsystems',
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const numericValue = parseInt(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return numericValue < 0 ? '' : value;
        },
    },
    {
        Header: 'Abzugssystem',
        accessor: 'pulloff_system',
    },
    {
        Header: 'Klemm- & Schneidvorrichtung',
        accessor: 'clampingcutting_device',
    },
    {
        Header: 'Abstand zwischen Nadelbetten',
        accessor: (row) => {
            // Kombiniere Abstand und Einheit
            const distance_needlebeds = row.distance_needlebeds;
            const unit = row.unit_distance_needlebeds_name;
            if (!distance_needlebeds && !unit) return null; // Fallback, falls Werte fehlen            
            return `${distance_needlebeds} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const distance_needlebeds = parseFloat(value);
                if (isNaN(distance_needlebeds)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "mm":
                        return distance_needlebeds * 1000 ; // 1 mm = 1000 µm
                    case "µm":
                        return distance_needlebeds; // bereits in µm
                    default:
                        return distance_needlebeds; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Abstand zwischen Nadelbetten']);
            const mmsB = convertToMM(rowB.values['Abstand zwischen Nadelbetten']);           
            return mmsA - mmsB;
        },

        
        /*accessor: row => `${row.distance_needlebeds} ${row.unit_distance_needlebeds_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurueck
            return floatValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'Sonstige',
        accessor: 'machinetype_others',
    },
]
